import { render, staticRenderFns } from "./DxProductsDataBase.vue?vue&type=template&id=2df91476&"
import script from "./DxProductsDataBase.vue?vue&type=script&lang=js&"
export * from "./DxProductsDataBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports